export interface OrgBusinessUnit {
  uId?: string;
  parentUId?: string;
  name?: string;
  description?: string;
  externalId?: string;
  level?: number;
  createdOn?: string;
  updatedOn?: string;
  lastEditedByUId?: string;
  lastEditedByName?: string;
  securityGroupUIds?: string[];
  options?: OrgBusinessUnitOptions;
  settings?: string;
  path?: string;
  userHasNoAccess?: boolean;
}

export enum OrgBusinessUnitOptions {
  None = 0,
  NotSelectable = 1,
  IncludeChildPermissions = 2
}

export interface OrgBusinessUnitsSelected {
  uIds?: string[];
}
